export default {"src":"/_next/static/media/sentimentChartDesktop.2bbf807e.svg","height":404,"width":743,"blurWidth":0,"blurHeight":0};